module.exports = __webpack_public_path__ + "img/career-support.50fe6994.png";